export default __webpack_public_path__ + "static/media/logo7_green.1caba380.png";